import { CommissionTypes } from 'constants/commissionTypes';

import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { RecordContextProvider, useRecordContext } from 'react-admin';
import { Chip } from 'shared/mui/Chips';
import { Stack } from 'shared/mui/Stack/Stack';
import { FunctionField } from 'shared/react-admin/Fields';
import { CommissionStatusChipField } from 'shared/react-admin/Fields/CommissionStatusChipField/CommissionStatusChipField';
import { Commission } from 'types/embedded/commission';

export const CommissionsShowChipFields: React.FC = () => {
  const translate = useTypedTranslate();
  const record = useRecordContext<Commission>();

  const calculationMethod = record?.calculationMethod;
  const calculationMethodDescription =
    calculationMethod && typeof calculationMethod !== 'string' ? calculationMethod.description : '';

  return (
    <Stack direction="row" gap={1} sx={{ marginBottom: '24px' }}>
      {record?.typeEnum?.value !== CommissionTypes.Regular && (
        <FunctionField
          render={(record: Commission) => (
            <Chip
              color="primary"
              label={`${translate('app.gatewayRules.commissionType')}: ${record?.typeEnum?.description}`}
              size="small"
            />
          )}
        />
      )}
      <FunctionField
        render={(record: Commission) => <Chip label={`ID: ${record?.originId}`} size="small" />}
      />
      <FunctionField
        render={(record: Commission) => (
          <Chip label={`${translate('app.table.name')}: ${record?.name}`} size="small" />
        )}
      />
      {!!calculationMethodDescription && (
        <FunctionField
          render={() => (
            <Chip
              label={`${translate('app.commissions.calculationMethod')}: ${calculationMethodDescription}`}
              size="small"
            />
          )}
        />
      )}
      <RecordContextProvider value={record?.status}>
        <CommissionStatusChipField source="description" />
      </RecordContextProvider>
    </Stack>
  );
};
